import { numberToCurrency } from '@admiin-com/ds-common';
import { WBIcon } from '@admiin-com/ds-web';
import { WBLink } from '@admiin-com/ds-web';
import { Task } from '@admiin-com/ds-graphql';
import { WBCollapse, WBFlex, WBTypography } from '@admiin-com/ds-web';
import { t } from 'i18next';
import { useState } from 'react';

export const LineItemsView = ({ task }: { task: Task }) => {
  const [viewLineItems, setViewLineItems] = useState(false);

  const onViewHideLineItems = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setViewLineItems(!viewLineItems);
  };

  return (
    <>
      {(task.futureLinkedTask?.lineItems?.length ||
        task.lineItems?.length ||
        0) > 0 && (
        <WBCollapse in={viewLineItems}>
          <WBFlex flexDirection={'column'} gap={1.5} alignItems={'center'}>
            {(task.futureLinkedTask?.lineItems || task.lineItems)?.map(
              (lineItem, index) =>
                lineItem && (
                  <WBFlex
                    key={index}
                    width={'100%'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                  >
                    <WBTypography variant="body2">{`${index + 1} ${
                      lineItem.description
                    }`}</WBTypography>
                    <WBFlex alignItems={'center'}>
                      <WBTypography variant="body2">
                        {numberToCurrency(lineItem.lineAmount ?? 0)}
                      </WBTypography>

                      {/* <WBIconButton
                        size="small"
                        onClick={() => {
                          console.log(lineItem);
                        }}
                      >
                        <LoadSvgIcon component={PenIcon} />
                      </WBIconButton> */}
                    </WBFlex>
                  </WBFlex>
                )
            )}
          </WBFlex>
        </WBCollapse>
      )}
      <WBLink onClick={onViewHideLineItems} variant="body2">
        <WBFlex alignItems="center" gap={1}>
          {viewLineItems
            ? t('collapseLineItems', { ns: 'tasks' })
            : t('showLineItems', { ns: 'tasks' })}
          <WBTypography
            sx={{
              transform: viewLineItems ? 'rotate(-90deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease-in-out',
            }}
            component={'span'}
            color={'primary.main'}
          >
            <WBIcon name="ChevronDown" size={2} color={'primary.main'} />
          </WBTypography>
        </WBFlex>
      </WBLink>
    </>
  );
};
